import React, { FC } from 'react';

import cn from 'classnames';
import { useRouter } from 'next/router';

import WapperIcon from '@components/Icon';
import { I18n } from '@utils/index';

import styles from './index.module.less';
interface linkProps {
  className?: string
}
export const GoBack: FC<linkProps> = (props) => {
  const { className } = props;
  const router = useRouter();
  const goBack = () => {
    router.back();
  }
  return (
    <div className={cn(styles.container, className)} >
      <a onClick={goBack} data-buried="go-back">
        <WapperIcon name="arrow-line" className={styles.arrowIcon} />{I18n.t('gRJfKdS4')}</a>
    </div>
  );
};
